document.addEventListener("turbo:load", () => {
  const input = document.getElementById("search-input");
  const button = document.getElementById("search-button");
  const resultsFrame = document.getElementById("search_results");
  const loading = document.getElementById("search-loading");

  if (!input || !button || !resultsFrame) return;

  const performSearch = () => {
    const query = input.value.trim();
    if (query.length < 3) return;

    if (loading) loading.style.display = "block";
    resultsFrame.innerHTML = "";

    fetch(`/cart/search_books?q=${encodeURIComponent(query)}`, {
      headers: { "Accept": "text/vnd.turbo-stream.html" }
    })
      .then(response => response.text())
      .then(html => {
        if (loading) loading.style.display = "none";
        resultsFrame.innerHTML = html;
      })
      .catch(err => {
        if (loading) loading.style.display = "none";
        console.error("Erro na busca:", err);
      });
  };

  button.addEventListener("click", performSearch);

  input.addEventListener("keypress", (e) => {
    if (e.key === "Enter") {
      performSearch();
    }
  });
});
